import i18n from 'i18next';
import Styles from './block.module.scss';
import { useLayoutEffect, useRef, useState } from 'react';
import { useEditor, useNode } from '@craftjs/core';
import { FormTextComponent, FormTextProps } from 'src/features/generalForms/builder/types/Text';
import { LayoutPanel, LogicPanel, StylesPanel, TextPanel } from 'src/features/generalForms/builder/layout/panels';

export const TextBlock: FormTextComponent = ({ text }) => {
  const { connectors } = useNode();
  const { connect, drag } = connectors;
  const {
    styles,
    actions: { setProp },
  } = useNode((node) => ({
    styles: node.data.custom,
  }));
  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  const [hasFocus, setHasFocus] = useState(false);

  const inputRef = useRef<HTMLTextAreaElement>(null);
  useLayoutEffect(() => {
    if (!inputRef.current) return;
    // Reset height - important to shrink on delete
    inputRef.current.style.height = 'inherit';
    inputRef.current.style.height = `${Math.max(inputRef.current.scrollHeight, 20)}px`;
  }, [text, styles.fontSize, styles.paddingLeft, styles.paddingTop]);

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} draggable={!hasFocus}>
      <textarea
        rows={1}
        ref={inputRef}
        style={styles}
        className={Styles.textEditableBuilder}
        placeholder={i18n.t('GeneralFormBuilder.Panels.Text.Placeholder')}
        disabled={!enabled}
        value={text}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        onChange={(e) => {
          setProp((prop: FormTextProps) => (prop.text = e.target.value), 500);
        }}
      />
    </div>
  );
};

const TextSettings = () => (
  <>
    <TextPanel sections={['Alignment', 'Style']} />
    <LayoutPanel sections={['Paddings']} />
    <StylesPanel sections={['Color']} />
    <LogicPanel sections={['Visible']} />
  </>
);

TextBlock.craft = {
  displayName: 'Text',
  rules: {
    canDrag: () => true,
  },
  related: {
    settings: TextSettings,
  },
  custom: { justifyContent: 'flex-start', fontSize: 14 },
};
